import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { deepCloneObject, IItinerary } from "@thekilroygroup/shared-ui";
import { ISearchForm } from "redux/searchForm";
import {
  getMetaSearchQuery,
  isOutdatedMetaSearchQuery,
  isValidMetaSearchQuery,
} from "../../validation/validateMetaRequest";
import { IMetaRedirectRequest } from "../../validation/validation.interfaces";
import { IAppConfigObject } from "appConfig.interfaces";
import DOMPurify from "dompurify";

interface IArg {
  itinerary: IItinerary;
  searchQuery: ISearchForm;
  searchRequestId: string;
  config: IAppConfigObject;
}
export const revalidateApi: any = createApi({
  reducerPath: "revalidateApi",
  baseQuery: fetchBaseQuery({
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    revalidate: builder.query({
      query: (arg: IArg) => {
        return {
          url: `${arg.config.FLIGHT_SEARCH_API_BASE_URL}/revalidate?topLevelDomain=${arg.config.TOP_LEVEL_DOMAIN}`,
          method: "POST",
          body: JSON.parse(
            DOMPurify.sanitize(JSON.stringify(getRequestBody(arg))),
          ),
        };
      },
    }),
  }),
});
export const { useLazyRevalidateQuery } = revalidateApi;

let getRequestBody = (arg: IArg) => {
  let revalidateQuery: IRevalidateRequest = deepCloneObject({
    ...arg.itinerary,
    searchRequestId: arg.searchRequestId,
  });

  if (
    isValidMetaSearchQuery(arg.searchQuery) &&
    !isOutdatedMetaSearchQuery(arg.searchQuery)
  ) {
    revalidateQuery["metaRedirectQuery"] = getMetaSearchQuery(arg.searchQuery);
  }

  return revalidateQuery;
};

interface IRevalidateRequest extends IItinerary {
  searchRequestId: string;
  metaRedirectQuery?: IMetaRedirectRequest;
}
